<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
        <el-button type="primary" plain class="title-btn" @click="back()">返回</el-button>
      </div>
      <div style="width: 500px;" class="detail">
        <el-form ref="ruleForm" :model="ruleForm" label-width="100px">
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="ruleForm.activityName" :disabled="true" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker v-model="ruleForm.activityTime" :disabled="true" type="daterange" range-separator="至" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input v-model="ruleForm.activityExplain" :disabled="true" type="textarea" :rows="4" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" label-width="100px">
          <template v-for="(row,index) in configForm.coupons[0].coupons">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" prop="activityReward">
              <div class="d-flex">
                <el-select v-model="row.couponId" style="width: 200px;" :disabled="true">
                  <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                </el-select>
                <el-input v-model="row.count" style="width: 100px;" :disabled="true" />
                <div class="ml-20">张</div>
                <i class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addCoupon(index)" />
                <i v-show="index!==0" class="icon-jia ml-20 el-icon-remove-outline" @click="delCoupon(index)" />
              </div>
              <div class="d-flex currentStock">当前库存：{{ queryCouponStock(row.couponId) }}</div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="partakeForm" :model="partakeForm" label-width="100px">
          <el-form-item label="可参与用户" prop="userType">
            <el-radio-group v-model="partakeForm.userType" :disabled="true">
              <el-radio v-for="(item, index) in userTypeItem" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择机构 -->
            <div v-show="partakeForm.userType==='2'" class="border">
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.mechanism"
                :props="treeDefaultProps"
                :check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.userType==='3'" class="border">
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.tag"
                :props="treeDefaultProps"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">用户参与记录</span>
      </div>
      <STable
        ref="firstDetailTableref"
        :url="url"
        :columns="columns"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        label-width="100px"
      />
    </el-card>
  </div>
</template>

<script>
import { numberfilter } from '@/utils/tool'
import { HOST } from '@/utils/host'
import { treeDisabled } from '@/utils/tool'
export default {
  props: {
    // 通过id查询详情信息
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      ruleForm: {
        activityName: '', // 活动名称
        activityTime: [], // 活动时间
        activityExplain: ''// 活动说明
      },
      // 所有的优惠券数据
      allCoupon: [],
      configForm: {
        coupons: [
          {
            coupons: [
              {
                couponId: '', // 优惠券类型
                count: ''// 优惠券数量
              }
            ]
          }
        ]
      },
      // 可参与用户字段的单选数据
      userTypeItem: [
        {
          label: '全部用户',
          id: '1'
        }, {
          label: '选择机构',
          id: '2'
        }, {
          label: '选择标签',
          id: '3'
        }
      ],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      partakeForm: {
        userType: 0, // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: []// 选择标签
      },
      url: '/activity/pageParticipation',
      columns: [
        {
          label: '所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'userName'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '领取时间',
          prop: 'createTime'
        }
      ],
      query: [
        {
          label: '所属企业',
          prop: 'orgName',
          placeholder: '请输入企业名称'
        }, {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        }, {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        }, {
          label: '领取时间',
          prop: 'timeRange',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          type: 'primary',
          handle: (resp) => {
            const url = HOST + '/activity/exportParticipation?activityId=' + this.id
            const data = this.$refs.firstDetailTableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出用户参与记录失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  computed: {},
  beforeMount() {
        this.id=this.$route.query.id
    this.url = '/activity/pageParticipation?activityId=' + this.id
  },
  mounted() {
    // 接收数据后回显赋值
    this.$nextTick(() => {
      // 获取全部优惠券数据
      this.loadCoupon()
      // 页面数据转换接口
      this.getData()
      // 查询全部企业方法
      this.getMechanismTree()
      // 查询全部标签方法
      this.getTagTree()
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType: '0' },
        callback: resp => {
          this.tagTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 页面数据转换方法
    getData() {
      this.$store.dispatch('form/handle', {
        url: '/activity/get',
        data: { id: this.id },
        method: 'get',
        callback: (record) => {
          this.ruleForm = {
            activityName: record.name, // 活动名称
            activityTime: [record.start, record.end], // 活动时间
            activityExplain: record.description // 活动说明
          }
          this.configForm = {
            coupons: record.coupons
          }
          this.partakeForm = {
            userType: record.userType, // 可参与用户的单选字段
            mechanism: record.userType === '2' ? record.userValue.split(',') : [], // 选择企业
            tag: record.userType === '3' ? record.userValue.split(',') : [] // 选择标签
          }
        }
      })
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      const val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      if (!val) return ''
      return val.stock || 0
    },
    back() {
      // this.$emit('backHome')
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .detail{
    /deep/.el-input__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-textarea__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-input{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-separator{
      color: #606266 !important;
    }
    /deep/.el-range__icon{
      color: #606266 !important;
    }
  }
  .d-flex{
    display: flex;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .border{
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
  .rewardStandard{
    /deep/.el-input{
      width: 70%;
      padding: 0 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/scanDetail.vue